import { createStore } from 'vuex'
import { login, getUserInfo } from '@/api/user'
import { registerDynamicRoutes } from '@/router/dynamicRoutes'
import router from '@/router'

export default createStore({
  state() {
    return {
      token: localStorage.getItem('token') || '',
      userInfo: null,
      dynamicRoutesLoaded: false
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_DYNAMIC_ROUTES_LOADED(state, val) {
      state.dynamicRoutesLoaded = val
    }
  },
  actions: {
    async login({ commit, dispatch }, userInfo) {
      const res = await login(userInfo)
      commit('SET_TOKEN', res.data.token)
      commit('SET_USER_INFO', res.data)
      // 登录后加载动态路由
      await dispatch('loadDynamicRoutes')
      return res.data
    },
    async getUserInfo({ commit, state }) {
      if (!state.token) return null
      try {
        const res = await getUserInfo()
        commit('SET_USER_INFO', res.data)
        return res.data
      } catch (error) {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
        return null
      }
    },
    async loadDynamicRoutes({ commit, state }) {
      if (state.dynamicRoutesLoaded) return
      try {
        const res = await fetch('/api/menus/tree', {
          headers: state.token ? { 'Authorization': `Bearer ${state.token}` } : {}
        }).then(r => r.json())
        if (res.code === 200 && res.data) {
          const dynamicRoutes = registerDynamicRoutes(res.data)
          for (const route of dynamicRoutes) {
            // 动态路由添加到 Layout 子路由下
            router.addRoute('Layout', route)
          }
          commit('SET_DYNAMIC_ROUTES_LOADED', true)
        }
      } catch (error) {
        console.error('加载动态路由失败', error)
      }
    },
    logout({ commit }) {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', null)
      commit('SET_DYNAMIC_ROUTES_LOADED', false)
    }
  },
  modules: {}
})